class CustomContentCardsValidator {
  constructor() {
    this.init();
  }

  init() {
    // Run validation only in Shopify theme editor
    if (window.Shopify && window.Shopify.designMode) {
      this.bindEvents();
      this.validateOnLoad();
    } else {
      // Run button functionality on frontend
      this.bindButtonEvents();
    }
  }

  bindEvents() {
    // Listen for block value changes
    document.addEventListener('input', (e) => {
      if (e.target.matches('input[data-setting-key="value"]')) {
        this.validateTotal();
      }
    });

    // Listen for block additions/deletions
    document.addEventListener('shopify:section:load', () => {
      this.validateTotal();
      this.bindButtonEvents();
    });

    document.addEventListener('shopify:block:select', () => {
      this.validateTotal();
    });

    document.addEventListener('shopify:block:deselect', () => {
      this.validateTotal();
    });

    // Bind button events for the frontend
    this.bindButtonEvents();
  }

  bindButtonEvents() {
    // Handle navigation button clicks
    document.querySelectorAll('.custom-content-cards__nav-button').forEach(button => {
      button.addEventListener('click', (e) => {
        const cardIndex = e.currentTarget.getAttribute('data-card-index');
        
        // Remove active class from all buttons
        document.querySelectorAll('.custom-content-cards__nav-button').forEach(btn => {
          btn.classList.remove('active');
        });
        
        // Remove active class from all card wrappers
        document.querySelectorAll('.custom-content-card-wrapper').forEach(wrapper => {
          wrapper.classList.remove('active');
        });
        
        // Add active class to clicked button
        e.currentTarget.classList.add('active');
        
        // Add active class to corresponding card wrapper
        const cardWrappers = document.querySelectorAll('.custom-content-card-wrapper');
        const targetWrapper = cardWrappers[cardIndex - 1]; // cardIndex is 1-based
        if (targetWrapper) {
          targetWrapper.classList.add('active');
        }
        
        this.scrollToCard(cardIndex);
      });
    });
  }

  scrollToCard(cardIndex) {
    const cards = document.querySelectorAll('.custom-content-card');
    const targetCard = cards[cardIndex - 1]; // cardIndex is 1-based
    
    if (targetCard) {
      targetCard.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      
      // Add a brief highlight effect
      targetCard.style.transform = 'scale(1.02)';
      targetCard.style.transition = 'transform 0.3s ease';
      
      setTimeout(() => {
        targetCard.style.transform = '';
      }, 600);
    }
  }

  validateOnLoad() {
    // Validate when page loads
    setTimeout(() => {
      this.validateTotal();
    }, 500);
  }

  validateTotal() {
    const valueInputs = document.querySelectorAll('input[data-setting-key="value"]');
    let total = 0;

    valueInputs.forEach(input => {
      const value = parseInt(input.value) || 0;
      total += value;
    });

    this.updateValidationUI(total);
    this.enforceLimit(total);
  }

  updateValidationUI(total) {
    // Console logging for debugging
    console.log(`Current total: ${total}¢`);
    
    if (total > 100) {
      console.warn(`Total exceeds $1.00 by ${total - 100}¢`);
    } else if (total === 100) {
      console.log('Perfect! Total equals $1.00');
    } else {
      console.log(`${100 - total}¢ remaining to reach $1.00`);
    }
  }

  enforceLimit(total) {
    const valueInputs = document.querySelectorAll('input[data-setting-key="value"]');
    
    valueInputs.forEach(input => {
      const currentValue = parseInt(input.value) || 0;
      const maxAllowed = 100 - (total - currentValue);
      
      // Set max attribute to prevent exceeding 100 cents total
      input.setAttribute('max', Math.max(0, maxAllowed));
      
      // Add visual feedback
      if (currentValue > maxAllowed) {
        input.style.borderColor = '#dc3545';
        input.style.backgroundColor = 'rgba(220, 53, 69, 0.1)';
      } else {
        input.style.borderColor = '';
        input.style.backgroundColor = '';
      }
    });
  }


}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CustomContentCardsValidator();
  });
} else {
  new CustomContentCardsValidator();
} 